var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverposition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / superposition"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H7V6H5.5V8H7V17H16V18.5H18V17H22V2ZM20 15H9V4H20V15Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15H2V13H4V15Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5H4V9.5H2V11.5Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22H9V20H11V22Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5H4V16.5H2V18.5Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V20H4V22Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22H7.5V20H5.5V22Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22H12.5V20H14.5V22Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8H4V6H2V8Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20H16V22H18V20Z",
    fill: "#647B8F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverposition);
export default __webpack_public_path__ + "static/media/overposition.c5c1a4c9.svg";
export { ForwardRef as ReactComponent };